import {
    OPEN_SIGNIN_DRAWER,
    CLOSE_SIGNIN_DRAWER,
    OPEN_SIGNUP_DRAWER,
    CLOSE_SIGNUP_DRAWER,
    OPEN_FORGOT_PASSWORD_DRAWER,
    CLOSE_FORGOT_PASSWORD_DRAWER,
    OPEN_DASHBOARD_DRAWER,
    CLOSE_DASHBOARD_DRAWER,
    OPEN_NAVIGATION_DRAWER,
    CLOSE_NAVIGATION_DRAWER,
} from './types';

const initialState = {
    signinDrawerOpen: false,
    signupDrawerOpen: false,
    forgotPasswordDrawerOpen: false,
    dashboardDrawerOpen: false,
    navigationDrawerOpen: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case OPEN_SIGNIN_DRAWER:
            return {
                ...state,
                signinDrawerOpen: true,
            };
        case CLOSE_SIGNIN_DRAWER:
            return {
                ...state,
                signinDrawerOpen: false,
            };
        case OPEN_SIGNUP_DRAWER:
            return {
                ...state,
                signupDrawerOpen: true,
            };
        case CLOSE_SIGNUP_DRAWER:
            return {
                ...state,
                signupDrawerOpen: false,
            };
        case OPEN_FORGOT_PASSWORD_DRAWER:
            return {
                ...state,
                forgotPasswordDrawerOpen: true,
            };
        case CLOSE_FORGOT_PASSWORD_DRAWER:
            return {
                ...state,
                forgotPasswordDrawerOpen: false,
            };
        case OPEN_DASHBOARD_DRAWER:
            return {
                ...state,
                dashboardDrawerOpen: true,
            };
        case CLOSE_DASHBOARD_DRAWER:
            return {
                ...state,
                dashboardDrawerOpen: false,
            };
        case OPEN_NAVIGATION_DRAWER:
            return {
                ...state,
                navigationDrawerOpen: true,
            };
        case CLOSE_NAVIGATION_DRAWER:
            return {
                ...state,
                navigationDrawerOpen: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/features/Layout/reducers.js